// Import core classes from shared package
import { ApiClient } from '@medprompt/shared';
import { AuthService } from '@medprompt/shared';

// Domain services
export { DocumentService } from './DocumentService';
export { InsightsService } from './InsightsService';
export { ConfigService } from './ConfigService';
export { OutcomeTaskService } from './OutcomeTaskService';
export { ReferralService } from './ReferralService';
export { PatientService, patientViewPath, patientIdentifierQuery } from './PatientService';
export { IssueService } from './IssueService';
export { ClinicService } from './ClinicService';
export { CommunicationService } from './CommunicationService';
export { NotificationService } from './NotificationService';
export { WorkflowService } from './WorkflowService';
export { ConsultationService } from './ConsultationService';
export { SystmOneService } from './SystmOneService';

// Create singleton instances for easy use
// AuthService is created first (no dependencies)
const authService = new AuthService();

// ApiClient depends on AuthService
const apiClient = new ApiClient(authService);

// Set the circular reference
apiClient.setAuthService(authService);

// Export singleton instances
export const sharedApiClient = apiClient;
export const sharedAuthService = authService;
